module.exports = __webpack_public_path__ + "img/b3.f7fb223.jpg";